import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'rp-home-expertise-exchange',
  standalone: true,
  templateUrl: './expertise-exchange.component.html',
  styleUrl: './../schema.base.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class ExpertiseExchangeComponent {}
